import React, { useState } from 'react';
import { MessageCircle, Mail } from 'lucide-react';
import { LegalModal, LegalType } from './LegalModal';
import { useLang } from '../contexts/LanguageContext';
import { LanguageToggle } from './LanguageToggle';
export function Footer() {
  const [legal, setLegal] = useState<LegalType | null>(null);
  const {
    t
  } = useLang();
  const links = [{
    href: '#servicios',
    label: t.footer.services
  }, {
    href: '#portafolio',
    label: t.footer.portfolio
  }, {
    href: '#nosotros',
    label: t.footer.about
  }, {
    href: '#resenas',
    label: t.footer.reviews
  }, {
    href: '#contacto',
    label: t.footer.contact
  }];
  return <footer className="bg-dark-200 pt-16 pb-8 border-t border-white/10" data-id="element-71" data-mp="3qcduj5trsjui">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72" data-mp="29ynnprb9nhh6">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-73" data-mp="2a19uvpu8vuyv">
          <img src="https://cdn.magicpatterns.com/uploads/evyospU31vfdfaKZswB6gc/Photoroom_20260524_142746.png" alt={t.footer.logoAlt} className="h-20 md:h-24 w-auto object-contain mb-4" data-id="element-74" data-mp="2ezuv3p9hyenb" />
          <p className="text-gold font-medium tracking-widest uppercase text-sm mb-6" data-id="element-75" data-mp="3gctr8txpeztz">
            {t.footer.tagline}
          </p>
          <LanguageToggle data-id="element-76" data-mp="3q83q58st2r3j" />
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-12 border-y border-white/10 py-8" data-id="element-77" data-mp="3q7bvc0718xeb">
          {links.map(link => <a key={link.href} href={link.href} className="text-gray-400 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-78" data-mp="33xcvurkbsqx">
              {link.label}
            </a>)}
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500" data-id="element-79" data-mp="cvtma1z3n5ag">
          <div className="flex gap-4" data-id="element-80" data-mp="qr5g875fkrqb">
            <button onClick={() => setLegal('privacy')} className="hover:text-white transition-colors" data-id="element-81" data-mp="mspqhvhyt597">
              {t.footer.privacy}
            </button>
            <span data-id="element-82" data-mp="yteeq1ruhklc">|</span>
            <button onClick={() => setLegal('terms')} className="hover:text-white transition-colors" data-id="element-83" data-mp="yupja3t46wdi">
              {t.footer.terms}
            </button>
          </div>

          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-84" data-mp="18lbvrp5jb6rz">
            <div className="flex items-center gap-2" data-id="element-85" data-mp="1ckt2elwp69yq">
              <MessageCircle className="w-4 h-4 text-white" data-id="element-86" data-mp="1hkfeut4pbm6h" />
              <span className="text-white font-bold" data-id="element-87" data-mp="1hiul35q7o79o">{t.footer.whatsapp}</span>
              <a href="https://wa.me/447311754270?text=WEBSITE" className="text-gold hover:text-gold-400 transition-colors" data-id="element-88" data-mp="1ml3eg36zxbcb">
                +44 7311 754270
              </a>
            </div>
            <div className="flex items-center gap-2" data-id="element-89" data-mp="3odhwr3dgcht9">
              <Mail className="w-4 h-4 text-white" data-id="element-90" data-mp="3tb189virmghi" />
              <span className="text-white font-bold" data-id="element-91" data-mp="2af3t5raxr5k5">{t.footer.email}</span>
              <a href="mailto:aselitecontractor@gmail.com" className="text-gold hover:text-gold-400 transition-colors" data-id="element-92" data-mp="2ah858wiznavi">
                aselitecontractor@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-2" data-id="element-93" data-mp="1wo8o6q3k58lu">
              <svg viewBox="0 0 24 24" className="w-4 h-4 text-white fill-current" aria-hidden="true" data-id="element-94" data-mp="1wlm9m6i91su4">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-95" data-mp="2pdpgzov3aril" />
              </svg>
              <span className="text-white font-bold" data-id="element-96" data-mp="18yxpde5rpoac">{t.footer.tiktok}</span>
              <a href="https://www.tiktok.com/@aselitecontractor" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-400 transition-colors" data-id="element-97" data-mp="13ys024mz0dvf">
                @aselitecontractor
              </a>
            </div>
          </div>

          <div data-id="element-98" data-mp="2iww1k405pgck">{t.footer.copyright}</div>
        </div>
      </div>

      <LegalModal type={legal} onClose={() => setLegal(null)} data-id="element-99" data-mp="2ntcm6o85dckw" />
    </footer>;
}